__turbopack_context__.v({
  "backward": "related-recipe-link-module__Dls9-a__backward",
  "body": "related-recipe-link-module__Dls9-a__body",
  "diet": "related-recipe-link-module__Dls9-a__diet",
  "eyebrow": "related-recipe-link-module__Dls9-a__eyebrow",
  "eyebrowIcon": "related-recipe-link-module__Dls9-a__eyebrowIcon",
  "eyebrowText": "related-recipe-link-module__Dls9-a__eyebrowText",
  "forward": "related-recipe-link-module__Dls9-a__forward",
  "link": "related-recipe-link-module__Dls9-a__link",
  "medallion": "related-recipe-link-module__Dls9-a__medallion",
  "title": "related-recipe-link-module__Dls9-a__title",
});
